import { Injectable } from '@angular/core';
import {
  isVersicherungssumeLowerOrEqual500000,
  isWertsachenValueDefault,
  isWertsachenValueGreaterThan100000,
} from '@ps20-frontend/utils';
import { VhvCheckoutProdukt } from '../store/model';

@Injectable({ providedIn: 'root' })
export class HoeherwertigerHausratUtils {
  maxVersicherungssummeToShowQuestionFeatureToggleActive = 500_000;

  showMechansicheSicherungKachel(vhvProdukt: VhvCheckoutProdukt): boolean {
    if (
      vhvProdukt.staendigBewohnt &&
      isVersicherungssumeLowerOrEqual500000(vhvProdukt.versicherungssumme) &&
      isWertsachenValueGreaterThan100000(vhvProdukt.wertsachenValue) &&
      isWertsachenValueDefault(vhvProdukt.wertsachenValue, vhvProdukt.versicherungssumme) &&
      vhvProdukt.hasWertsachen === false
    ) {
      return false;
    }
    if (
      vhvProdukt.staendigBewohnt &&
      isWertsachenValueGreaterThan100000(vhvProdukt.wertsachenValue)
    ) {
      return true;
    }
    return !vhvProdukt.staendigBewohnt && vhvProdukt.versicherungssumme > 50000;
  }

  showWertbehaeltnisseKachel(vhvProdukt: VhvCheckoutProdukt): boolean {
    return vhvProdukt.wertsachen?.verschlusspflichtige?.tresoreVorhanden;
  }

  showEinbruchmeldeanlageKachel(vhvProdukt: VhvCheckoutProdukt): boolean {
    return (
      vhvProdukt.tresor?.eintraege?.some(tresor => tresor.ueberwachung) ||
      vhvProdukt.wertsachen?.nichtVerschlusspflichtige?.einbruchmeldeanlageVorhanden
    );
  }

  showZusaetzlicheInformationenAbschnitt(vhvProdukt: VhvCheckoutProdukt): boolean {
    if (this.showMechansicheSicherungKachel(vhvProdukt)) {
      return true;
    }
    if (this.showWertbehaeltnisseKachel(vhvProdukt)) {
      return true;
    }
    return this.showEinbruchmeldeanlageKachel(vhvProdukt);
  }

  shouldShowOldSection(vhvProdukt: VhvCheckoutProdukt, forceNewSection = false): boolean {
    if (forceNewSection) {
      return false;
    }
    return (
      !vhvProdukt.showWertsachensummeQuestion &&
      !this.showZusaetzlicheInformationenAbschnitt(vhvProdukt)
    );
  }
  checkIfShouldShowWersachensummeQuestion(vhvProdukt: VhvCheckoutProdukt): boolean {
    return !(
      vhvProdukt.staendigBewohnt &&
      isVersicherungssumeLowerOrEqual500000(vhvProdukt.versicherungssumme) &&
      isWertsachenValueGreaterThan100000(vhvProdukt.wertsachenValue) &&
      !isWertsachenValueDefault(vhvProdukt.wertsachenValue, vhvProdukt.versicherungssumme) && !vhvProdukt.isTragerisikoSelected
    );
  }
}
